import React from "react";
import { ITabData } from "../../../Model/UI";
import { DetailTabsComponent } from "../../DetailTabsComponent/DetailTabsComponent";

import { ACCESS_APPROVALS_ITEMS_TAB_ID } from "../AccessApprovalsUtil";
import { IAccessApprovals } from "Model/ServerResponse/IAccessApprovals";
import { IAccessApprovalsTab } from "Model/ServerResponse/IAccessApprovalsTab";
import { AccessApprovalsItem } from "../AccessApprovalsItem/AccessApprovalsItem";

export interface IAccessApprovalsTabsProp {
  accessApprovals: IAccessApprovals;
}

export function AccessApprovalsTabs(props: IAccessApprovalsTabsProp) {
  function tabsUI(props) {
    const data = getTabsData(props.accessApprovals.tabs);
    return <DetailTabsComponent tabs={data}></DetailTabsComponent>;
  }

  function getTabsData(tabs: IAccessApprovalsTab[]): ITabData[] {
    let tdata: ITabData[] = [];

    tabs.forEach((tab: IAccessApprovalsTab) => {
      let tabInfo: ITabData = {
        tabId: "",
        title: tab.title,
        imageSrc: "",
        count: tab.count,
      };

      switch (tab.tabId) {
        case ACCESS_APPROVALS_ITEMS_TAB_ID:
          tabInfo.tabId = ACCESS_APPROVALS_ITEMS_TAB_ID;
          tabInfo.imageSrc = "./DetailTab/details_icn.svg";
          tabInfo.getTabUI = itemsUI;
          break;
        default:
          break;
      }
      tdata.push(tabInfo);
    });
    return tdata;
  }

  function itemsUI() {
    return <AccessApprovalsItem accessApprovalsData={props.accessApprovals}></AccessApprovalsItem>;
  }

  return tabsUI(props);
}
